import React from "react";
import "./Become_Partner.css";
import { Container } from "react-bootstrap";

const Become_Partner = () => {
  return (
    <section className="hero_section">
      <Container>
        <div className="img_col">
          <img
            src="/assets/images/home/become_partner/group-1.png"
            alt="team"
            className="hero-image"
          />
        </div>

        {/* ============ MOBILE VIEW ============= */}

        <div className="text_holder">
          <h2 className="hero_title">
            Who Can <span>Become a Partner?</span>
          </h2>
          <p className="hero_subtitle">
            <span>All you need is passion. </span>Whether you love education or
            entrepreneurship, we equip you with every tool and training resource
            necessary to succeed, regardless of your sales background.
          </p>
        </div>
      </Container>
    </section>
  );
};

export default Become_Partner;
